/* keen-slider has no built-in autoplay, so the USP bar carousel supplies its
   own. Rotation pauses while the pointer is over the bar and while the user is
   dragging, so a slide can't move out from under a click. */

const AutoplayPlugin =
  (delay = 5000) =>
  (slider) => {
    let timeout
    let paused = false

    function clear() {
      clearTimeout(timeout)
    }

    function next() {
      clear()
      if (paused) {
        return
      }
      timeout = setTimeout(() => {
        slider.next()
      }, delay)
    }

    slider.on("created", () => {
      slider.container.addEventListener("mouseover", () => {
        paused = true
        clear()
      })
      slider.container.addEventListener("mouseout", () => {
        paused = false
        next()
      })
      next()
    })
    slider.on("dragStarted", () => {
      paused = true
      clear()
    })
    slider.on("animationEnded", () => {
      paused = false
      next()
    })
    slider.on("updated", next)
    slider.on("destroyed", clear)
  }

export default AutoplayPlugin
